module.exports = __webpack_public_path__ + "img/tasks.ce76b5e3.svg";